import { render, staticRenderFns } from "./DrugProcurement.vue?vue&type=template&id=92a053b0&scoped=true&"
import script from "./DrugProcurement.vue?vue&type=script&lang=js&"
export * from "./DrugProcurement.vue?vue&type=script&lang=js&"
import style0 from "./DrugProcurement.vue?vue&type=style&index=0&id=92a053b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a053b0",
  null
  
)

export default component.exports